module.exports = __webpack_public_path__ + "img/validator.589dad26.jpg";